import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [form, setForm] = useState({});
  useEffect(() => { api.get("/settings/public").then((r) => setForm(r.data || {})); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/settings", form); toast.success("Configurações salvas"); }
    catch (err) { toast.error("Erro"); }
  };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <div className="space-y-6 max-w-3xl">
      <div><div className="label">Configurações</div><h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Site & Contato</h1></div>
      <form onSubmit={save} className="ci-card p-6 space-y-4" data-testid="admin-settings-form">
        <div><label className="label">Nome do Projeto</label><input value={form.project_name || ""} onChange={(e)=>set("project_name", e.target.value)} className="ci-input mt-1"/></div>
        <div><label className="label">Frase Principal</label><textarea rows={2} value={form.tagline || ""} onChange={(e)=>set("tagline", e.target.value)} className="ci-input mt-1 resize-none"/></div>
        <div><label className="label">Texto Sobre</label><textarea rows={4} value={form.about_text || ""} onChange={(e)=>set("about_text", e.target.value)} className="ci-input mt-1 resize-none"/></div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="label">Instagram Handle</label><input value={form.instagram_handle || ""} onChange={(e)=>set("instagram_handle", e.target.value)} className="ci-input mt-1"/></div>
          <div><label className="label">Instagram URL</label><input value={form.instagram_url || ""} onChange={(e)=>set("instagram_url", e.target.value)} className="ci-input mt-1"/></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="label">WhatsApp (c/ DDI)</label><input placeholder="5511999998888" value={form.whatsapp_number || ""} onChange={(e)=>set("whatsapp_number", e.target.value)} className="ci-input mt-1"/></div>
          <div><label className="label">Mensagem padrão WhatsApp</label><input value={form.whatsapp_message || ""} onChange={(e)=>set("whatsapp_message", e.target.value)} className="ci-input mt-1"/></div>
        </div>
        <div><label className="label">E-mail de contato</label><input type="email" value={form.contact_email || ""} onChange={(e)=>set("contact_email", e.target.value)} className="ci-input mt-1"/></div>
        <button type="submit" className="btn-primary">Salvar Configurações</button>
      </form>
    </div>
  );
}
